module.exports = __webpack_public_path__ + "static/img/react.0c93f257.svg";